import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TranslationProps } from '@/config/locale/type';

import dialogInfo from '../../config/locale/snackBarInfo';

export type SnackBarType = 'error' | 'warning' | 'info' | 'success';

export interface SnackBarState {
  open?: boolean;
  type: SnackBarType;
  msg: TranslationProps;
}

const snackBarInitState: SnackBarState = {
  open: false,
  type: 'info',
  msg: dialogInfo.INFO_0001,
};

const snackBarSlice = createSlice({
  name: 'snackBar',
  initialState: snackBarInitState,
  reducers: {
    onSnackBarOpen: (state, action: PayloadAction<SnackBarState>) => {
      const temp = state;
      temp.open = true;
      temp.type = action.payload.type;
      temp.msg = action.payload.msg;
      return temp;
    },
    onSnackBarClose: (state) => {
      const temp = state;
      temp.open = false;
      return temp;
    },
  },
});

export const { onSnackBarOpen, onSnackBarClose } = snackBarSlice.actions;

export default snackBarSlice;
